








































import {Guid} from "@/core/common/guid";
import ReportDataParseComponent from "@/modules/cbc/components/form/ReportDataParse.vue";
import ReportDataValidateComponent from "@/modules/cbc/components/form/ReportDataValidate.vue";
import {CbcMixin} from "@/modules/cbc/mixins";
import {
	Message,
	ReportData,
	ReportDataCreateRequest,
	ReportDataParseRequest,
	ReportDataValidationRequest,
	SupportedSchema
} from "@/modules/cbc/models";
import CompanyDisplayComponent from "@/modules/country/components/CompanyDisplay.vue";
import {CountryMixin} from "@/modules/country/mixins";
import {Component, Emit, Mixins, Prop} from "vue-property-decorator";

@Component({
	components: {
		CompanyDisplayComponent,
		ReportDataParseComponent,
		ReportDataValidateComponent
	}
})
export default class ReportDataListComponent extends Mixins(CbcMixin, CountryMixin) {
	@Prop()
	public readonly reportData!: ReportData[];
	public headers: any[] = [
		{
			text: "Name",
			value: "message.refId",
			align: "start"
		},
		{
			text: "Jurisdiction",
			value: "message.jurisdiction",
			align: "start"
		},
		{
			text: "Reporting Period",
			value: "message.reportingPeriod",
			align: "start"
		},
		{
			text: "Version",
			value: "version"
		},
		{
			text: 'Action',
			value: 'action',
			sortable: false
		}
	];

	public onClickRow(row: ReportData) {
		this.$router.push({
			name: "cbc.report.detail",
			params: {id: row.id.toString()}
		});
	}

	public onGetNameSupportedSchema(supportedSchema: SupportedSchema): string | undefined {
		return this.supportedSchemas.find(x => x.id === supportedSchema)!.name!;
	}

	@Emit("create")
	public onCreate() {
		return {
			data: {
				id: Guid.create().toString(),
				version: SupportedSchema.OECD_200,
				reports: [],
				message: {} as Message
			} as ReportData
		} as ReportDataCreateRequest;
	}

	@Emit("parse")
	public onParse(request: ReportDataParseRequest) {
		return request;
	}

	@Emit("validate")
	public onValidate(request: ReportDataValidationRequest) {
		return request;
	}
}
